import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\InvoiceItem\GetInvoiceItemByIdController::__invoke
* @see app/Http/Controllers/InvoiceItem/GetInvoiceItemByIdController.php
* @route '/api/invoicing/{invoice}/invoice-item/{invoice_item}'
*/
const GetInvoiceItemByIdController = (args: { invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetInvoiceItemByIdController.url(args, options),
    method: 'get',
})

GetInvoiceItemByIdController.definition = {
    methods: ["get","head"],
    url: '/api/invoicing/{invoice}/invoice-item/{invoice_item}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\InvoiceItem\GetInvoiceItemByIdController::__invoke
* @see app/Http/Controllers/InvoiceItem/GetInvoiceItemByIdController.php
* @route '/api/invoicing/{invoice}/invoice-item/{invoice_item}'
*/
GetInvoiceItemByIdController.url = (args: { invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
            invoice_item: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
        invoice_item: typeof args.invoice_item === 'object'
        ? args.invoice_item.id
        : args.invoice_item,
    }

    return GetInvoiceItemByIdController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace('{invoice_item}', parsedArgs.invoice_item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvoiceItem\GetInvoiceItemByIdController::__invoke
* @see app/Http/Controllers/InvoiceItem/GetInvoiceItemByIdController.php
* @route '/api/invoicing/{invoice}/invoice-item/{invoice_item}'
*/
GetInvoiceItemByIdController.get = (args: { invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetInvoiceItemByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\InvoiceItem\GetInvoiceItemByIdController::__invoke
* @see app/Http/Controllers/InvoiceItem/GetInvoiceItemByIdController.php
* @route '/api/invoicing/{invoice}/invoice-item/{invoice_item}'
*/
GetInvoiceItemByIdController.head = (args: { invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetInvoiceItemByIdController.url(args, options),
    method: 'head',
})

export default GetInvoiceItemByIdController